/**
 * @flow
 * @relayHash 0f8238eb34418d75ff2a0a5d456a1fd1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProposalStatus = "ACCEPTED" | "DRAFT" | "DRAFT_WITH_CONFLICTS" | "ESCALATED" | "PROPOSED_OUTSIDE_MEETING";
export type ProposeOutsideMeetingInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  proposalId: string,
|};
export type MutationContext = {|
  organizationId: string
|};
export type ProposeOutsideMeetingMutationVariables = {|
  input: ProposeOutsideMeetingInput
|};
export type ProposeOutsideMeetingMutationResponse = {|
  +proposeOutsideMeeting: ?{|
    +proposal: {|
      +id: string,
      +databaseId: string,
      +status: ProposalStatus,
      +expectedResponseCount: number,
      +receivedResponseCount: number,
    |}
  |}
|};
export type ProposeOutsideMeetingMutation = {|
  variables: ProposeOutsideMeetingMutationVariables,
  response: ProposeOutsideMeetingMutationResponse,
|};
*/


/*
mutation ProposeOutsideMeetingMutation(
  $input: ProposeOutsideMeetingInput!
) {
  proposeOutsideMeeting(input: $input) {
    proposal {
      id
      databaseId
      status
      expectedResponseCount
      receivedResponseCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProposeOutsideMeetingPayload",
    "kind": "LinkedField",
    "name": "proposeOutsideMeeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Proposal",
        "kind": "LinkedField",
        "name": "proposal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "databaseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expectedResponseCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedResponseCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposeOutsideMeetingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposeOutsideMeetingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0f8238eb34418d75ff2a0a5d456a1fd1",
    "metadata": {},
    "name": "ProposeOutsideMeetingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c1355060b4257e11a87a35cf9d1f95d0';

module.exports = node;
